module.exports = __webpack_public_path__ + "static/media/sdmt6.a1b30250.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdmt/sdmt6.svg
// module id = 346
// module chunks = 0